import * as React from 'react';

interface IFiduciaLogo {
  size: string;
  color: string;
}

function SvgFiduciaLogo(props: IFiduciaLogo) {
  return (
    <svg viewBox="0 0 435.9 118.84" width={props.size}>
      <defs>
        <style>{`.prefix__cls-1{fill: ${props.color}} .prefix__cls-2{fill:#c5a66e}`}</style>
      </defs>
      <g id="prefix__Layer_2 container" data-name="Layer 2">
        <g id="prefix__Layer_1-2" data-name="Layer 1">
          <path
            className="prefix__cls-1"
            d="M27.28 42.21a70.49 70.49 0 0110-19.62l.41-.57a.72.72 0 00-.58-1.16H.73a.73.73 0 00-.73.73V94.5a.73.73 0 00.73.73h29.13a.73.73 0 00.66-1 71.08 71.08 0 01-3.24-52z"
          />
          <path
            className="prefix__cls-2"
            d="M74.18.07a.09.09 0 00-.11-.07 67.46 67.46 0 00-36.71 28.73c-.4.64-.79 1.29-1.16 1.94a67.37 67.37 0 00-.13 66.67.09.09 0 00.16-.07 63.5 63.5 0 018.91-54.54c4.35-6.19 16.76-16.38 16.76-16.38C75.17 15.18 74.29 1.38 74.18.07z"
          />
          <path
            className="prefix__cls-2"
            d="M49.58 74.17a51.73 51.73 0 019.84-12.79l.52-.49a29.14 29.14 0 004-4.73c.34-.5.67-1 1-1.55a29.47 29.47 0 004.09-15c0-.72 0-1.43-.08-2.13a2.83 2.83 0 000-.29A54.62 54.62 0 0042 63.63a51.15 51.15 0 00-2.24 5.53 54.59 54.59 0 007.45 49.65.09.09 0 00.15-.09 51.49 51.49 0 012.19-44.55z"
          />
          <path
            className="prefix__cls-1"
            d="M65 61.64l-.33.24A18.66 18.66 0 0062 64.13a45.51 45.51 0 00-15 30.41.65.65 0 00.65.69h26a.73.73 0 00.73-.73V57.87a.38.38 0 00-.47-.37A27 27 0 0065 61.64zM145.64 41.72c.6 0 .9.24.9.9v2.83c0 .66-.3.9-.9.9h-38.42v13.89h36.38c.6 0 .84.24.84.9V64c0 .6-.24.84-.84.84h-36.38v16.9c0 .6-.24.9-.84.9h-3.85c-.66 0-.9-.3-.9-.9V42.62c0-.6.24-.9.9-.9zM165.74 81.71c0 .6-.25.9-.85.9h-3.84c-.67 0-.91-.3-.91-.9V42.62c0-.6.24-.9.91-.9h3.84c.6 0 .85.3.85.9zM180.24 82.61c-.66 0-.91-.3-.91-.9V42.62c0-.6.25-.9.85-.9h24.17c18.34 0 23.75 5.47 23.75 12.27v16.35c0 6.8-5.41 12.27-23.75 12.27zm4.69-36.26V78h19.42c13.65 0 18.1-3.13 18.1-8.54V54.89c0-5.41-4.45-8.54-18.1-8.54zM351.68 71.43c0 6.49-5.47 12.14-23.81 12.14s-23.81-5.65-23.81-12.14V52.91c0-6.5 5.53-12.15 23.81-12.15s23.81 5.65 23.81 12.15v2.7c0 .6-.24.9-.84.9h-3.91a.8.8 0 01-.9-.9v-2c0-5-4.39-8.18-18.16-8.18s-18.16 3.13-18.16 8.42v16.67c0 5.3 4.45 8.42 18.16 8.42S346 75.82 346 70.76V68.6c0-.66.3-1 .9-1h3.91c.6 0 .84.3.84 1zM370.88 81.71c0 .6-.24.9-.85.9h-3.84c-.67 0-.91-.3-.91-.9V42.62c0-.6.24-.9.91-.9H370c.61 0 .85.3.85.9zM386.22 82.61h-3.73c-.6 0-1-.36-.66-.9l24-39.09c.37-.54.61-.9 1.33-.9h3.55a1.37 1.37 0 011.32.9l23.75 39.09c.36.54-.06.9-.6.9h-3.85c-.78 0-1-.36-1.26-.9l-5.35-8.78H393l-5.41 8.78c-.34.54-.53.9-1.37.9zm9.44-14.07H422l-9.86-16.11c-1.44-2.41-2.41-4.15-3.25-5.78-1 1.75-2.28 4.09-3.31 5.78z"
          />
          <path
            className="prefix__cls-2"
            d="M242.6 36.13c-.6 0-.9-.24-.9-.84v-3.85c0-.66.3-.9.9-.9h47c.6 0 .9.24.9.9v3.85c0 .6-.3.84-.9.84z"
          />
          <path
            className="prefix__cls-1"
            d="M247.35 70.52c0 5.3 4.63 8.42 18.76 8.42s18.76-3.12 18.76-8.42v-27.9c0-.6.24-.9.9-.9h3.85c.6 0 .84.3.84.9v28.81c0 6.49-5.65 12.14-24.35 12.14s-24.41-5.65-24.41-12.14V42.62c0-.6.24-.9.9-.9h3.85c.66 0 .9.3.9.9z"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgFiduciaLogo;
